/**
 * Labstep
 *
 * @module components/OrderRequest/Action/RemovePurchaseOrder
 * @desc Action to set purchase_order_id for orderRequest to null
 */

import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import type React from 'react';
import type { OrderRequestActionRemovePurchaseOrderProps } from './types';

export const OrderRequestActionRemovePurchaseOrder: React.FC<
  OrderRequestActionRemovePurchaseOrderProps
> = ({ orderRequest }) => (
  <EntityActionUpdate
    id={orderRequest.id}
    entityName={orderRequest.entityName}
    body={{ purchase_order_id: null }}
    actionComponentProps={{
      type: 'option',
      text: 'Remove',
    }}
  />
);
